import { Spacer } from "../atoms/Atoms"
import React from "react"
import { HomeCard } from "./Home"
import { ArrowLink } from "../atoms/links/ArrowLink"
import { H2 } from "@carrotfertility/carotene"

const ProfileCompletionCard = ({ halfWidth }) => (
  <HomeCard halfWidth={halfWidth}>
    <H2>Keep your profile up to date</H2>
    <Spacer height={0.25} />
    <span className="publico-text fw4 lh-copy black-80">
      Journeys can change. Your profile information helps us better assist you.
    </span>
    <Spacer height={1} />
    <ArrowLink to="/account">Update my profile</ArrowLink>
  </HomeCard>
)

export default ProfileCompletionCard
